<template>
    <div>
      <PopUp v-if="showPopup" @closePopup="onClosePopup" />
      <div class="page-content">
        <div class="page-content-2">
            <div class="center-text own-title margin-bottom-20">
              Explore The World
            </div>
            <div class="content">
              <ExploreBanner
                video="explore_the_world/video/Generali Star Convention - Korea.mp4"
                modal="korea-modal"
                title="Seoul"
                title1="Korea"
                menu="menu-korea"
                positionSlide2="240px"
                image="korea.png"
                description1="Generali Star Convention"
                description2="Qualifying Period: 01 JAN 2024 to 31 DEC 2024"
                description3=""
                link="korea"
                
                y1y2agentspvi="138,000"
                agentspvi="168,000"
                leaderpspvi="208,000"
                directunitpvi="504,000"
                grouppvi="1,008,000"
                
                badge="explore_the_world/logo/korea.png"
                bannerBadge="korea-badge.png"
                />
              <ExploreBanner
                video="explore_the_world/video/Generali Elite Convention - USA.mp4"
                modal="usa-modal"
                title="USA"
                title1="Los Angeles & Las Vegas"
                menu="menu-usa"
                positionSlide2="145px"
                image="usa.png"
                description1="Generali Elite Convention"
                description2="Qualifying Period: 01 JAN 2024 to 31 DEC 2024"
                description3=""
                link="usa"
      
                y1y2agentspvi="288,000"
                agentspvi="348,000"
                leaderpspvi="428,000"
                directunitpvi="1,044,000"
                grouppvi="2,088,000"

                badge="explore_the_world/logo/usa.png"
                bannerBadge="usa-badge.png"
                />
              <ExploreBanner
                video="explore_the_world/video/Generali RisingStar Convention - Thailand.mp4"
                modal="thailand-modal"
                title="Bangkok"
                title1="Thailand"
                menu="menu-thailand"
                positionSlide2="145px"
                image="thailand.png"
                description1="Generali Rising Star"
                description2="Qualifying Period: 01 JAN 2024 to 31 DEC 2024"
                description3=""
                link="thailand"

                y1y2agentspvi=""
                agentspvi=""
                leaderpspvi=""
                directunitpvi=""
                grouppvi=""

                badge="explore_the_world/logo/thailand.png"
                bannerBadge="thailand-badge.png"
                />
            </div>
            <div class="divider divider-margins"></div>
        </div>
      </div>
    </div>
</template>
<style scoped>
/* .theme-dark .divider {
    background-color: unset !important;
}
.theme-dark .page-content{
  display: contents;
}
.theme-dark .page-content-2{
  max-width: 1000px;
  margin: 0 auto;

} */
/* .divider-margins {
    margin: 0px 15px 60px 15px;
}
.content {
    margin: 0px 0 20px 0 !important;
} */
/* .mb-10 {
  margin-bottom: 10px;
} */
</style>
<script>
import PopUp from '../components/PopUp.vue'
import ExploreBanner from '../components/ExploreBanner.vue'
export default {
  name: 'Explore',
  components: {
    ExploreBanner,
    PopUp,
  },
  data() {
      return {
        showPopup: true,
      };
  },
  methods: {
    onClosePopup() {
      this.showPopup = false;
    },
  },
  mounted(){
      document.querySelector(".header-s").style.display = "block";
      document.querySelector(".header").style.zIndex = "96";
  },
}
</script>
